export default {
  //login
  //
  LOG_IN: "/v1/auth/login",
  LOG_OUT: "/v1/auth/logout",
  GET_PROFILE: "/v1/users/profile",

  REGISTRATION: "/v1/register",

  COUNTRY_LIST: "/v1/countries/admin/all",
  LANGUAGE_LIST: "/v1/languages/admin/all",
  COUNTRY: "/v1/countries/admin",

  //user
  //
  USER: "/v1/users/admin",
  USER_VARS: "/v1/user-vars/admin",
  USER_ALL: "/v1/users/admin/by-group/7",
  USER_FILTER: "/v1/users/admin/filter",
  USER_GROUP: "/v1/user-groups/admin/all",
  GET_BUYER: "/v1/users/admin/by-group/3",
  BUYER_DEPOSIT: "v1/leads/admin/deposit-by-buyers",
  COMPAIGN: "/v1/leads/admin/integration-filter",
  COMPAIGN_EXPORT: "/v1/leads/admin/integration-export",
  COUNTRY_DEPOSIT: "/v1/leads/admin/deposit-by-countries",

  SPENDING: "/v1/analytics-spending/admin",
  SPENDING_ALERT: "/v1/analytics-spending-notifications/admin/notify",

  //team
  //
  TEAM: "/v1/teams/admin",
  TEAM_FILTER: "/v1/teams/admin/filter",
  TEAM_USER: "/v1/teams/admin/users/",
  TEAM_USER_FILTER: "/v1/teams/admin/users/filter",
  TEAM_ALL: "/v1/teams/admin/all",

  //lead
  //
  LEAD: "/v1/leads/admin",
  LEAD_PARAMS: "/v1/lead-params/admin/all",
  LEAD_PARAMS_ITEMS: "/v1/lead-params/admin/filter-by-value",
  CREATE_LEAD: "/v1/leads/create",
  LEAD_STATUS: "/v1/lead-statuses/admin/all",
  EXPORT_LEAD: "/v1/leads/admin/export/csv",

  LEAD_JOBS: "/v1/distribution-jobs/admin",

  LEAD_REIMPORT: "/v1/distribution-distributions/system/reimport",
  LEAD_REVOKE: "/v1/distribution-distributions/system/revoke",

  //client
  //
  CLIENT: "/v1/buyer-clients/admin",
  CLIENT_ALL: "/v1/buyer-clients/admin/all",

  //integration
  //
  INTEGRATION: "/v1/buyer-integrations/admin",
  INTEGRATION_TYPE: "/v1/distribution-integration-types/admin/all",
  INTEGRATION_LOG: "/v1/log-buyer-integrations/system",
  INTEGRATION_AVAILABLE: "/v1/buyer-integrations/system/available",
  INTEGRATION_HISTORY: "/v1/analytics-integration-history/admin",

  //log
  //
  LOG_GLOBAL: "/v1/log-distribution-globals/system",
  DISTRIBUTION_LEAD_LOG: "/v1/distribution-distributions/admin",
  LEAD_LOG: "/v1/log-lead-leads/system/full",

  GET_LOG_STATUS: "/v1/distribution-statuses?perPage=100&page=1",

  //queue
  //

  QUEUE: "/v1/distribution-options/admin/queue-mode",
  SEND_LEAD: "/v1/distribution-distributions/system/single",
  TELEGRAM_CONFIG: "/v1/lead-metrics/config",
  TELEGRAM_REC: "/v1/lead-metrics/reconciliation/config",
  TELEGRAM_CONFIG_SEND: "/v1/lead-metrics/send",
  TELEGRAM_REC_SEND: "/v1/lead-metrics/reconciliation/send",
};
